"use client"

import type React from "react"

interface WhatsAppFormProps {
  phone: string
  message: string
  onPhoneChange: (phone: string) => void
  onMessageChange: (message: string) => void
}

const WhatsAppForm: React.FC<WhatsAppFormProps> = ({ phone, message, onPhoneChange, onMessageChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="whatsapp-phone-input">Phone Number:</label>
      <div className="phone-input-container">
        <input
          id="whatsapp-phone-input"
          type="tel"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          placeholder="Phone number with country code (e.g., 911234567890)"
          className="text-input"
        />
        <p className="input-help">
          Enter phone number with country code, without + or spaces. For example, for US number +1 (123) 456-7890, enter
          11234567890
        </p>
      </div>

      <label htmlFor="whatsapp-message-input">Message (Optional):</label>
      <textarea
        id="whatsapp-message-input"
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
        placeholder="Your WhatsApp message"
        className="text-input text-area"
        rows={3}
      />
    </div>
  )
}

export default WhatsAppForm
